import { render, staticRenderFns } from "./BranchSelect.vue?vue&type=template&id=68d16a4c&"
import script from "./BranchSelect.vue?vue&type=script&lang=js&"
export * from "./BranchSelect.vue?vue&type=script&lang=js&"
import style0 from "./BranchSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports